import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';

import { MediaFeatureState } from '../states';

export const selectMediaFeatureState: MemoizedSelector<object, MediaFeatureState> = createFeatureSelector<MediaFeatureState>('mediaFeature');


